/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tree_Type_8_TitleInputs */

const en_tree_type_8_title = /** @type {(inputs: Tree_Type_8_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cherry Blossom`)
};

const ar_tree_type_8_title = /** @type {(inputs: Tree_Type_8_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`شجرة الكرز`)
};

const de_tree_type_8_title = /** @type {(inputs: Tree_Type_8_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kirschblüte`)
};

const es_tree_type_8_title = /** @type {(inputs: Tree_Type_8_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Flor de cerezo`)
};

const fr_tree_type_8_title = /** @type {(inputs: Tree_Type_8_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cerisier en fleur`)
};

const it_tree_type_8_title = /** @type {(inputs: Tree_Type_8_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fiore di Ciliegio`)
};

const ja_tree_type_8_title = /** @type {(inputs: Tree_Type_8_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`桜`)
};

const ko_tree_type_8_title = /** @type {(inputs: Tree_Type_8_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`벚꽃`)
};

const pt_br_tree_type_8_title = /** @type {(inputs: Tree_Type_8_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cerejeira`)
};

const ru_tree_type_8_title = /** @type {(inputs: Tree_Type_8_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сакура`)
};

const th_tree_type_8_title = /** @type {(inputs: Tree_Type_8_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ต้นซากุระ`)
};

const tr_tree_type_8_title = /** @type {(inputs: Tree_Type_8_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kiraz Çiçeği`)
};

const zh_cn_tree_type_8_title = /** @type {(inputs: Tree_Type_8_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`樱花`)
};

const zh_tw_tree_type_8_title = /** @type {(inputs: Tree_Type_8_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`櫻花`)
};

/**
* | output |
* | --- |
* | "Cherry Blossom" |
*
* @param {Tree_Type_8_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const tree_type_8_title = /** @type {((inputs?: Tree_Type_8_TitleInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tree_Type_8_TitleInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tree_type_8_title(inputs)
	if (locale === "ar") return ar_tree_type_8_title(inputs)
	if (locale === "de") return de_tree_type_8_title(inputs)
	if (locale === "es") return es_tree_type_8_title(inputs)
	if (locale === "fr") return fr_tree_type_8_title(inputs)
	if (locale === "it") return it_tree_type_8_title(inputs)
	if (locale === "ja") return ja_tree_type_8_title(inputs)
	if (locale === "ko") return ko_tree_type_8_title(inputs)
	if (locale === "pt_br") return pt_br_tree_type_8_title(inputs)
	if (locale === "ru") return ru_tree_type_8_title(inputs)
	if (locale === "th") return th_tree_type_8_title(inputs)
	if (locale === "tr") return tr_tree_type_8_title(inputs)
	if (locale === "zh_cn") return zh_cn_tree_type_8_title(inputs)
	return zh_tw_tree_type_8_title(inputs)
});